// Strength Trainers Data - Using the strength coding system ($x&*()-+=[]{}:;|<>)
// COMPLETE VERSION - 6 programs per trainer

// Axel Ironside's workout programs (converted from Android data)
const axelIronsidePrograms = [
    {
        id: 'power-lifts',
        name: 'Power Lifts',
        description: 'Maximal strength development through fundamental powerlifting movements and progressive loading protocols',
        pattern: '$&=+*|', // chest, shoulder, leg, abs, arm, hip
        reps: 5,
        sets: 3,
        focus: 'Powerlifting Foundation'
    },
    {
        id: 'beast-mode',
        name: 'Beast Mode',
        description: 'Beast Mode requires both monstrous strength and savage intensity for extreme strength performance',
        pattern: '$$*+=', // chest, chest, arm, abs, leg
        reps: 6,
        sets: 3,
        focus: 'Beast Intensity'
    },
    {
        id: 'maximum-load',
        name: 'Maximum Load',
        description: 'Maximum loading requires systematic neural adaptation and structural integrity for handling maximal loads',
        pattern: 'xx+:>', // back, back, abs, trap, overall
        reps: 5,
        sets: 3,
        focus: 'Maximum Strength'
    },
    {
        id: 'iron-force',
        name: 'Iron Force',
        description: 'Iron Force demands both structural strength and functional power for maximal force production',
        pattern: '$&)(*-', // chest, shoulder, tricep, bicep, arm, forearm
        reps: 6,
        sets: 3,
        focus: 'Force Development'
    },
    {
        id: 'deadlift-domination',
        name: 'Deadlift Domination',
        description: 'Deadlift mastery requires optimal posterior chain development and perfect mechanical execution',
        pattern: 'xx(+>', // back, back, bicep, abs, overall
        reps: 5,
        sets: 4,
        focus: 'Deadlift Mastery'
    },
    {
        id: 'squat-master',
        name: 'Squat Master',
        description: 'Squat mastery develops physical and mental resilience through optimal lower body development',
        pattern: ';+:+>', // obliques, abs, trap, abs, overall
        reps: 6,
        sets: 3,
        focus: 'Squat Excellence'
    }
];

// Magnus Steele's workout programs (converted from Android data)
const magnusSteelePrograms = [
    {
        id: 'olympic-lifts',
        name: 'Olympic Lifts',
        description: 'Olympic lifting demands perfect technique, explosive power, and unwavering confidence',
        pattern: '$&|*=', // chest, shoulder, hip, arm, leg
        reps: 4,
        sets: 3,
        focus: 'Olympic Foundation'
    },
    {
        id: 'clean-and-jerk',
        name: 'Clean & Jerk',
        description: 'The clean and jerk requires precise coordination between lower and upper body power',
        pattern: '=[{+:', // leg, quad, glute, abs, trap
        reps: 4,
        sets: 3,
        focus: 'Clean & Jerk Mastery'
    },
    {
        id: 'snatch-master',
        name: 'Snatch Master',
        description: 'The snatch demands explosive speed, precise positioning, and total body coordination',
        pattern: '=[:*&', // leg, quad, trap, arm, shoulder
        reps: 4,
        sets: 3,
        focus: 'Snatch Excellence'
    },
    {
        id: 'explosive-power',
        name: 'Explosive Power',
        description: 'Explosive power is built through developing the rate of force development in key movement patterns',
        pattern: '=|{x>', // leg, hip, glute, back, overall
        reps: 5,
        sets: 3,
        focus: 'Power Development'
    },
    {
        id: 'technical-mastery',
        name: 'Technical Mastery',
        description: 'Technical proficiency in Olympic lifting requires positional awareness and pattern recognition',
        pattern: '&=-:+', // shoulder, leg, forearm, trap, abs
        reps: 4,
        sets: 3,
        focus: 'Technical Excellence'
    },
    {
        id: 'competition-prep',
        name: 'Competition Prep',
        description: 'Competition preparation requires peaking both physical capabilities and psychological readiness',
        pattern: '=&[*>', // leg, shoulder, quad, arm, overall
        reps: 3,
        sets: 4,
        focus: 'Competition Ready'
    }
];

// Brock Hammer's workout programs (converted from Android data)
const brockHammerPrograms = [
    {
        id: 'strongman-basics',
        name: 'Strongman Basics',
        description: 'Foundational strongman training develops the raw strength necessary for all advanced events',
        pattern: 'x:$=+', // back, trap, chest, leg, abs
        reps: 5,
        sets: 3,
        focus: 'Strongman Foundation'
    },
    {
        id: 'atlas-stones',
        name: 'Atlas Stones',
        description: 'Stone lifting requires both spinal integrity and explosive hip drive',
        pattern: 'x:+{=', // back, trap, abs, glute, leg
        reps: 4,
        sets: 3,
        focus: 'Stone Lifting'
    },
    {
        id: 'log-press',
        name: 'Log Press',
        description: 'Log pressing demands stability, shoulder integrity, and confident lockout',
        pattern: '&$:-+', // shoulder, chest, trap, forearm, abs
        reps: 4,
        sets: 3,
        focus: 'Log Press Mastery'
    },
    {
        id: 'farmers-carry',
        name: 'Farmer\'s Carry',
        description: 'Farmer\'s carries develop total body strength, grip endurance, and mental toughness',
        pattern: '-:(x>', // forearm, trap, bicep, back, overall
        reps: 4,
        sets: 3,
        focus: 'Carrying Power'
    },
    {
        id: 'tire-flips',
        name: 'Tire Flips',
        description: 'Tire flipping combines deadlift strength with explosive follow-through',
        pattern: '={x:+', // leg, glute, back, trap, abs
        reps: 4,
        sets: 3,
        focus: 'Flip Power'
    },
    {
        id: 'brute-force',
        name: 'Brute Force',
        description: 'Total brute force requires both mental and physical barriers to be shattered',
        pattern: 'x:=+>', // back, trap, leg, abs, overall
        reps: 4,
        sets: 3,
        focus: 'Brute Strength'
    }
];

// Kane Titanium's workout programs (converted from Android data)
const kaneTitaniumPrograms = [
    {
        id: 'power-development',
        name: 'Power Development',
        description: 'True power development requires precise manipulation of both force and velocity through progressive loading',
        pattern: '$&=*+', // chest, shoulder, leg, arm, abs
        reps: 5,
        sets: 3,
        focus: 'Power Foundation'
    },
    {
        id: 'explosive-strength',
        name: 'Explosive Strength',
        description: 'Explosive strength combines maximal force output with minimal time constraints for elite performance',
        pattern: '$*&+=', // chest, arm, shoulder, abs, leg
        reps: 5,
        sets: 3,
        focus: 'Explosive Power'
    },
    {
        id: 'athletic-force',
        name: 'Athletic Force',
        description: 'Athletic force production requires sport-specific power development with multi-planar capabilities',
        pattern: 'x&+:>', // back, shoulder, abs, trap, overall
        reps: 6,
        sets: 3,
        focus: 'Athletic Development'
    },
    {
        id: 'triple-extension',
        name: 'Triple Extension',
        description: 'Triple extension is the foundation of human power output through coordinated joint extension',
        pattern: '=}[{>', // leg, calves, quad, glute, overall
        reps: 6,
        sets: 3,
        focus: 'Extension Power'
    },
    {
        id: 'plyometric-domination',
        name: 'Plyometric Domination',
        description: 'Plyometric training develops the stretch-shortening cycle for optimal power production',
        pattern: '=}[+>', // leg, calves, quad, abs, overall
        reps: 5,
        sets: 3,
        focus: 'Plyometric Excellence'
    },
    {
        id: 'vertical-power',
        name: 'Vertical Power',
        description: 'Vertical power development requires specific force vectors and proper sequential recruitment',
        pattern: '=}[+>', // leg, calves, quad, abs, overall
        reps: 5,
        sets: 3,
        focus: 'Vertical Development'
    }
];

// Rex Savage's workout programs (converted from Android data)
const rexSavagePrograms = [
    {
        id: 'raw-strength',
        name: 'Raw Strength',
        description: 'Raw strength is built through primitive movement patterns and brutal intensity',
        pattern: '$x=*+', // chest, back, leg, arm, abs
        reps: 6,
        sets: 3,
        focus: 'Primal Strength'
    },
    {
        id: 'pure-power',
        name: 'Pure Power',
        description: 'Pure power requires maximizing both force output and explosive intent for devastating performance',
        pattern: '$x*+=', // chest, back, arm, abs, leg
        reps: 5,
        sets: 3,
        focus: 'Pure Power'
    },
    {
        id: 'primal-force',
        name: 'Primal Force',
        description: 'Primal force taps into our ancestral movement patterns for authentic strength',
        pattern: 'x=+:>', // back, leg, abs, trap, overall
        reps: 6,
        sets: 3,
        focus: 'Primal Development'
    },
    {
        id: 'brutal-intensity',
        name: 'Brutal Intensity',
        description: 'Brutal intensity training breaks through both physical and mental barriers',
        pattern: '$x&*>', // chest, back, shoulder, arm, overall
        reps: 8,
        sets: 3,
        focus: 'Savage Intensity'
    },
    {
        id: 'savage-method',
        name: 'Savage Method',
        description: 'The savage method combines primitive strength with strategic progression',
        pattern: '$&=x+', // chest, shoulder, leg, back, abs
        reps: 5,
        sets: 3,
        focus: 'Savage Training'
    },
    {
        id: 'ultimate-beast-mode',
        name: 'Ultimate Beast Mode',
        description: 'Ultimate beast mode transcends normal human limitations through ferocious determination',
        pattern: '$x&=+', // chest, back, shoulder, leg, abs
        reps: 5,
        sets: 3,
        focus: 'Beast Mastery'
    }
];

// Dominic Stone's workout programs (converted from Android data)
const dominicStonePrograms = [
    {
        id: 'athletic-power',
        name: 'Athletic Power',
        description: 'Athletic power must be built with sport-specific adaptations in mind for competitive success',
        pattern: '$&=*+', // chest, shoulder, leg, arm, abs
        reps: 5,
        sets: 3,
        focus: 'Athletic Excellence'
    },
    {
        id: 'sports-domination',
        name: 'Sports Domination',
        description: 'Sports domination requires both general athletic ability and sport-specific skills',
        pattern: '$&*+=', // chest, shoulder, arm, abs, leg
        reps: 6,
        sets: 3,
        focus: 'Sports Mastery'
    },
    {
        id: 'crushing-strength',
        name: 'Crushing Strength',
        description: 'Crushing strength combines raw power with functional application for physical dominance',
        pattern: 'x:&+>', // back, trap, shoulder, abs, overall
        reps: 5,
        sets: 3,
        focus: 'Crushing Power'
    },
    {
        id: 'dynamic-force',
        name: 'Dynamic Force',
        description: 'Dynamic force training develops the ability to express strength through movement',
        pattern: '$&*+>', // chest, shoulder, arm, abs, overall
        reps: 6,
        sets: 3,
        focus: 'Dynamic Strength'
    },
    {
        id: 'field-dominator',
        name: 'Field Dominator',
        description: 'Field domination requires specific strength qualities that directly translate to sport performance',
        pattern: '&$=+>', // shoulder, chest, leg, abs, overall
        reps: 5,
        sets: 3,
        focus: 'Field Excellence'
    },
    {
        id: 'functional-beast',
        name: 'Functional Beast',
        description: 'The functional beast excels in any physical challenge through complete athletic development',
        pattern: '&$x+>', // shoulder, chest, back, abs, overall
        reps: 5,
        sets: 3,
        focus: 'Functional Dominance'
    }
];

// Strength trainers data structure
const strengthTrainersData = {
    'axel-ironside': {
        id: 'axel-ironside',
        name: 'Axel Ironside',
        specialization: 'Powerlifting & Maximum Strength Specialist',
        image: '/assets/images/v69.jpg',
        experience: '18 years',
        category: 'strength',
        intro: `Axel Ironside transformed his physique through years of competitive powerlifting and strength coaching. With his imposing build, intense focus, and wolf-like determination, Axel specializes in raw strength development that combines brute power with technical perfection. After dominating the powerlifting circuit, he developed training methodologies that help individuals achieve their maximum strength potential in any environment. "True strength is measured in plates, not words," is his core training philosophy. Axel's background blending powerlifting, strongman training, and strength sciences creates remarkably effective programs that develop extraordinary power alongside impressive structural integrity through systematic strength progression.`,
        programs: axelIronsidePrograms
    },
    'magnus-steele': {
        id: 'magnus-steele',
        name: 'Magnus Steele',
        specialization: 'Olympic Weightlifting & Technical Performance Specialist',
        image: '/assets/images/v70.jpg',
        experience: '16 years',
        category: 'strength',
        intro: `Magnus Steele forged his expertise through years of Olympic weightlifting competition and elite coaching. With his commanding presence, eagle-like precision, and methodical approach, Magnus specializes in technical Olympic lifting that combines explosive power with flawless execution. After representing his country internationally, he developed training systems that transform athletes into efficient lifting machines. "Technique before weight, always," is his core training philosophy. Magnus's background blending Olympic lifting, sports performance, and biomechanics creates highly effective programs that develop extraordinary technical proficiency alongside impressive power production through precision strength training.`,
        programs: magnusSteelePrograms
    },
    'brock-hammer': {
        id: 'brock-hammer',
        name: 'Brock "The Beast" Hammer',
        specialization: 'Strongman & Functional Strength Specialist',
        image: '/assets/images/v72.jpg',
        experience: '20 years',
        category: 'strength',
        intro: `Brock "The Beast" Hammer transformed his body through years of competitive strongman training and brute force strength development. With his intimidating physique, powerful presence, and beast-like determination, Brock specializes in raw functional strength that combines immense power with unstoppable force. After dominating the international strongman circuit, he developed training methodologies that help individuals develop incredible carrying, lifting, and pulling strength. "If you can't use it in real life, it's just for show," is his core training philosophy. Brock's background blending strongman events, power development, and brute force training creates remarkably effective programs that develop extraordinary functional strength alongside impressive work capacity through real-world strength applications.`,
        programs: brockHammerPrograms
    },
    'kane-titanium': {
        id: 'kane-titanium',
        name: 'Kane Titanium',
        specialization: 'Explosive Power & Athletic Performance Specialist',
        image: '/assets/images/v76.jpg',
        experience: '15 years',
        category: 'strength',
        intro: `Kane Titanium forged his physique through years of elite power development and explosive strength training. With his titanium-tough build, explosive athleticism, and mechanical precision, Kane specializes in advanced power production that combines scientific principles with cutting-edge training methods. After setting records in multiple power-based sports, he developed training systems that help athletes maximize their explosive potential in any athletic endeavor. "Power isn't just about strength—it's about applying force with maximum velocity," is his core training philosophy. Kane's background blending sports science, Olympic lifting, and plyometric training creates exceptionally effective programs that develop extraordinary explosive power alongside impressive athletic performance through scientific strength development.`,
        programs: kaneTitaniumPrograms
    },
    'rex-savage': {
        id: 'rex-savage',
        name: 'Rex Savage',
        specialization: 'Primal Strength & Savage Intensity Specialist',
        image: '/assets/images/v81.jpg',
        experience: '17 years',
        category: 'strength',
        intro: `Rex Savage forged his body through primal strength training and raw, instinctive approaches to muscle development. With his savage physique, predatory intensity, and animalistic power, Rex specializes in brutal strength development that combines primitive training methods with relentless effort. After conquering the underground strength scene, he developed training methodologies that transform ordinary individuals into unstoppable forces of nature. "Strength isn't manufactured—it's unleashed," is his core training philosophy. Rex's background blending primitive strength techniques, instinctive training, and brutal intensity creates extraordinarily effective programs that develop raw power alongside unbreakable mental toughness through primal strength methods.`,
        programs: rexSavagePrograms
    },
    'dominic-stone': {
        id: 'dominic-stone',
        name: 'Dominic "Crusher" Stone',
        specialization: 'Athletic Power & Sports Performance Specialist',
        image: '/assets/images/v85.jpg',
        experience: '19 years',
        category: 'strength',
        intro: `Dominic "Crusher" Stone built his formidable physique through years of athletic competition and power-based training. With his rock-solid build, explosive athleticism, and dynamic presence, Dominic specializes in athletic power development that combines functional strength with sport-specific performance. After dominating multiple athletic disciplines, he developed training systems that transform ordinary athletes into sporting powerhouses. "Power that doesn't transfer to the field is wasted potential," is his core training philosophy. Dominic's background blending strength athletics, sports science, and power development creates exceptionally effective programs that develop extraordinary athletic capabilities alongside impressive functional strength through sport-specific training methods.`,
        programs: dominicStonePrograms
    }
};

// Export functions
export const getStrengthTrainerData = (trainerId) => {
    return strengthTrainersData[trainerId] || null;
};

export const getAllStrengthTrainers = () => {
    return Object.values(strengthTrainersData);
};

export default strengthTrainersData;